import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconButton from "@material-ui/core/IconButton";
import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import React, { forwardRef, useMemo } from "react";
import { Link, LinkProps } from "react-router-dom";

// Size button's width/height to be equal to the standard MUI Button's min-height
const styles = (theme: Theme) =>
  createStyles({
    buttonRoot: {
      width: 36,
      height: 36,
      padding: 0,
      fontSize: theme.typography.body2.fontSize,
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      boxShadow: theme.shadows[2],
      marginRight: theme.spacing(1),
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
    buttonDisabled: {
      backgroundColor: theme.palette.action.disabledBackground,
    },
  });

interface TableBodyRowButtonProps extends WithStyles<typeof styles> {
  icon: IconProp;
  title?: string;
  titlePlacement?:
    | "bottom-end"
    | "bottom-start"
    | "bottom"
    | "left-end"
    | "left-start"
    | "left"
    | "right-end"
    | "right-start"
    | "right"
    | "top-end"
    | "top-start"
    | "top";
  disabled?: boolean;
  linkUrl?: string;
  onClick?: () => void;
}

export const TableBodyRowButtonComponent = (props: TableBodyRowButtonProps) => {
  const { icon, title, titlePlacement, disabled, linkUrl, onClick, classes } = props;

  // Use a Link component for the Action if a linkUrl is specified
  const ActionLink = useMemo(
    () =>
      linkUrl
        ? forwardRef<any, Omit<LinkProps, "to">>((linkProps, ref) => <Link ref={ref} to={linkUrl} {...linkProps} />)
        : undefined,
    [linkUrl],
  );

  const iconButtonComponent = (
    <IconButton
      disabled={disabled}
      aria-label={title}
      component={ActionLink as any}
      onClick={onClick}
      classes={{ root: classes.buttonRoot, disabled: classes.buttonDisabled }}
    >
      <FontAwesomeIcon icon={icon} />
    </IconButton>
  );
  return title ? (
    <Tooltip enterDelay={300} placement={titlePlacement || "right"} title={title}>
      {iconButtonComponent}
    </Tooltip>
  ) : (
    iconButtonComponent
  );
};

export const TableBodyRowButton = withStyles(styles)(TableBodyRowButtonComponent);
